export interface Country {
  id: string
  flag: string
  name: string
  currency: 'GNF' | 'FCFA' | 'SLE' | 'LRD' | 'GHS' | 'NGN' | 'GMD' | 'CVE'
    | 'DZD' | 'AOA' | 'BWP' | 'BIF' | 'KMF' | 'CDF' | 'DJF' | 'EGP' | 'ERN' | 'SZL' | 'ETB' | 'KES' | 'LSL' | 'LYD' | 'MGA' | 'MWK' | 'MUR' | 'MRU' | 'MAD' | 'MZN' | 'NAD' | 'UGX' | 'RWF' | 'STN' | 'SCR' | 'SOS' | 'SDG' | 'SSP' | 'ZAR' | 'TZS' | 'TND' | 'ZMW' | 'ZWG'
  dialCode: string
}

/** Pays où une boutique peut être créée (cf. ShopCountry.tsx, étape pays & devise) : les 54 pays d'Afrique,
 *  triés par nom. Plusieurs pays partagent le franc CFA (zones UEMOA et CEMAC) ; les autres ont leur propre
 *  devise — cf. ShopCountry.tsx pour l'affichage par devise. */
export const COUNTRIES: Country[] = [
  { id: 'ZA', flag: '🇿🇦', name: 'Afrique du Sud', currency: 'ZAR', dialCode: '+27' },
  { id: 'DZ', flag: '🇩🇿', name: 'Algérie', currency: 'DZD', dialCode: '+213' },
  { id: 'AO', flag: '🇦🇴', name: 'Angola', currency: 'AOA', dialCode: '+244' },
  { id: 'BJ', flag: '🇧🇯', name: 'Bénin', currency: 'FCFA', dialCode: '+229' },
  { id: 'BW', flag: '🇧🇼', name: 'Botswana', currency: 'BWP', dialCode: '+267' },
  { id: 'BF', flag: '🇧🇫', name: 'Burkina Faso', currency: 'FCFA', dialCode: '+226' },
  { id: 'BI', flag: '🇧🇮', name: 'Burundi', currency: 'BIF', dialCode: '+257' },
  { id: 'CM', flag: '🇨🇲', name: 'Cameroun', currency: 'FCFA', dialCode: '+237' },
  { id: 'CV', flag: '🇨🇻', name: 'Cap-Vert', currency: 'CVE', dialCode: '+238' },
  { id: 'KM', flag: '🇰🇲', name: 'Comores', currency: 'KMF', dialCode: '+269' },
  { id: 'CG', flag: '🇨🇬', name: 'Congo-Brazzaville', currency: 'FCFA', dialCode: '+242' },
  { id: 'CI', flag: '🇨🇮', name: "Côte d'Ivoire", currency: 'FCFA', dialCode: '+225' },
  { id: 'DJ', flag: '🇩🇯', name: 'Djibouti', currency: 'DJF', dialCode: '+253' },
  { id: 'EG', flag: '🇪🇬', name: 'Égypte', currency: 'EGP', dialCode: '+20' },
  { id: 'ER', flag: '🇪🇷', name: 'Érythrée', currency: 'ERN', dialCode: '+291' },
  { id: 'SZ', flag: '🇸🇿', name: 'Eswatini', currency: 'SZL', dialCode: '+268' },
  { id: 'ET', flag: '🇪🇹', name: 'Éthiopie', currency: 'ETB', dialCode: '+251' },
  { id: 'GA', flag: '🇬🇦', name: 'Gabon', currency: 'FCFA', dialCode: '+241' },
  { id: 'GM', flag: '🇬🇲', name: 'Gambie', currency: 'GMD', dialCode: '+220' },
  { id: 'GH', flag: '🇬🇭', name: 'Ghana', currency: 'GHS', dialCode: '+233' },
  { id: 'GN', flag: '🇬🇳', name: 'Guinée', currency: 'GNF', dialCode: '+224' },
  { id: 'GQ', flag: '🇬🇶', name: 'Guinée équatoriale', currency: 'FCFA', dialCode: '+240' },
  { id: 'GW', flag: '🇬🇼', name: 'Guinée-Bissau', currency: 'FCFA', dialCode: '+245' },
  { id: 'KE', flag: '🇰🇪', name: 'Kenya', currency: 'KES', dialCode: '+254' },
  { id: 'LS', flag: '🇱🇸', name: 'Lesotho', currency: 'LSL', dialCode: '+266' },
  { id: 'LR', flag: '🇱🇷', name: 'Liberia', currency: 'LRD', dialCode: '+231' },
  { id: 'LY', flag: '🇱🇾', name: 'Libye', currency: 'LYD', dialCode: '+218' },
  { id: 'MG', flag: '🇲🇬', name: 'Madagascar', currency: 'MGA', dialCode: '+261' },
  { id: 'MW', flag: '🇲🇼', name: 'Malawi', currency: 'MWK', dialCode: '+265' },
  { id: 'ML', flag: '🇲🇱', name: 'Mali', currency: 'FCFA', dialCode: '+223' },
  { id: 'MA', flag: '🇲🇦', name: 'Maroc', currency: 'MAD', dialCode: '+212' },
  { id: 'MU', flag: '🇲🇺', name: 'Maurice', currency: 'MUR', dialCode: '+230' },
  { id: 'MR', flag: '🇲🇷', name: 'Mauritanie', currency: 'MRU', dialCode: '+222' },
  { id: 'MZ', flag: '🇲🇿', name: 'Mozambique', currency: 'MZN', dialCode: '+258' },
  { id: 'NA', flag: '🇳🇦', name: 'Namibie', currency: 'NAD', dialCode: '+264' },
  { id: 'NE', flag: '🇳🇪', name: 'Niger', currency: 'FCFA', dialCode: '+227' },
  { id: 'NG', flag: '🇳🇬', name: 'Nigéria', currency: 'NGN', dialCode: '+234' },
  { id: 'UG', flag: '🇺🇬', name: 'Ouganda', currency: 'UGX', dialCode: '+256' },
  { id: 'CD', flag: '🇨🇩', name: 'RD Congo', currency: 'CDF', dialCode: '+243' },
  { id: 'CF', flag: '🇨🇫', name: 'République centrafricaine', currency: 'FCFA', dialCode: '+236' },
  { id: 'RW', flag: '🇷🇼', name: 'Rwanda', currency: 'RWF', dialCode: '+250' },
  { id: 'ST', flag: '🇸🇹', name: 'São Tomé-et-Príncipe', currency: 'STN', dialCode: '+239' },
  { id: 'SN', flag: '🇸🇳', name: 'Sénégal', currency: 'FCFA', dialCode: '+221' },
  { id: 'SC', flag: '🇸🇨', name: 'Seychelles', currency: 'SCR', dialCode: '+248' },
  { id: 'SL', flag: '🇸🇱', name: 'Sierra Leone', currency: 'SLE', dialCode: '+232' },
  { id: 'SO', flag: '🇸🇴', name: 'Somalie', currency: 'SOS', dialCode: '+252' },
  { id: 'SD', flag: '🇸🇩', name: 'Soudan', currency: 'SDG', dialCode: '+249' },
  { id: 'SS', flag: '🇸🇸', name: 'Soudan du Sud', currency: 'SSP', dialCode: '+211' },
  { id: 'TZ', flag: '🇹🇿', name: 'Tanzanie', currency: 'TZS', dialCode: '+255' },
  { id: 'TD', flag: '🇹🇩', name: 'Tchad', currency: 'FCFA', dialCode: '+235' },
  { id: 'TG', flag: '🇹🇬', name: 'Togo', currency: 'FCFA', dialCode: '+228' },
  { id: 'TN', flag: '🇹🇳', name: 'Tunisie', currency: 'TND', dialCode: '+216' },
  { id: 'ZM', flag: '🇿🇲', name: 'Zambie', currency: 'ZMW', dialCode: '+260' },
  { id: 'ZW', flag: '🇿🇼', name: 'Zimbabwe', currency: 'ZWG', dialCode: '+263' },
]

/** Libellé long de chaque devise (ShopCountry.tsx, ShopProfile.tsx). */
export const CURRENCY_LABELS: Record<Country['currency'], string> = {
  GNF: 'Franc guinéen',
  FCFA: 'Franc CFA',
  SLE: 'Leone',
  LRD: 'Dollar libérien',
  GHS: 'Cedi ghanéen',
  NGN: 'Naira nigérian',
  GMD: 'Dalasi gambien',
  CVE: 'Escudo capverdien',
  DZD: 'Dinar algérien',
  AOA: 'Kwanza angolais',
  BWP: 'Pula botswanais',
  BIF: 'Franc burundais',
  KMF: 'Franc comorien',
  CDF: 'Franc congolais',
  DJF: 'Franc djiboutien',
  EGP: 'Livre égyptienne',
  ERN: 'Nakfa érythréen',
  SZL: 'Lilangeni swazi',
  ETB: 'Birr éthiopien',
  KES: 'Shilling kényan',
  LSL: 'Loti lesothan',
  LYD: 'Dinar libyen',
  MGA: 'Ariary malgache',
  MWK: 'Kwacha malawien',
  MUR: 'Roupie mauricienne',
  MRU: 'Ouguiya mauritanien',
  MAD: 'Dirham marocain',
  MZN: 'Metical mozambicain',
  NAD: 'Dollar namibien',
  UGX: 'Shilling ougandais',
  RWF: 'Franc rwandais',
  STN: 'Dobra santoméen',
  SCR: 'Roupie seychelloise',
  SOS: 'Shilling somalien',
  SDG: 'Livre soudanaise',
  SSP: 'Livre sud-soudanaise',
  ZAR: 'Rand sud-africain',
  TZS: 'Shilling tanzanien',
  TND: 'Dinar tunisien',
  ZMW: 'Kwacha zambien',
  ZWG: 'Zimbabwe Gold (ZiG)',
}

export interface PhoneCountry {
  id: string
  flag: string
  name: string
  dialCode: string
}

/** Pays proposés par le sélecteur d'indicatif téléphonique (Login/CreateAccount/ForgotPassword,
 *  Team.tsx, NewArrival.tsx, etc.) — liste mondiale (ISO 3166-1, ~247 entrées), volontairement
 *  DÉCOUPLÉE de COUNTRIES : un numéro de téléphone peut être de n'importe quel pays, alors que
 *  COUNTRIES ne couvre que les pays où une boutique peut être créée (devise supportée). Générée à
 *  partir de world-countries (npm) le 2026-09-05 — idd.root+suffix comme indicatif, sauf quelques
 *  territoires à indicatif partagé/multiple corrigés à la main (Vatican, Sahara Occidental,
 *  Sainte-Hélène, Svalbard) où l'indicatif root+premier-suffixe n'aurait pas donné un résultat correct. */
export const PHONE_COUNTRIES: PhoneCountry[] = [
  { id: 'AF', flag: '🇦🇫', name: "Afghanistan", dialCode: '+93' },
  { id: 'ZA', flag: '🇿🇦', name: "Afrique du Sud", dialCode: '+27' },
  { id: 'AL', flag: '🇦🇱', name: "Albanie", dialCode: '+355' },
  { id: 'DZ', flag: '🇩🇿', name: "Algérie", dialCode: '+213' },
  { id: 'DE', flag: '🇩🇪', name: "Allemagne", dialCode: '+49' },
  { id: 'AD', flag: '🇦🇩', name: "Andorre", dialCode: '+376' },
  { id: 'AO', flag: '🇦🇴', name: "Angola", dialCode: '+244' },
  { id: 'AI', flag: '🇦🇮', name: "Anguilla", dialCode: '+1264' },
  { id: 'AG', flag: '🇦🇬', name: "Antigua-et-Barbuda", dialCode: '+1268' },
  { id: 'SA', flag: '🇸🇦', name: "Arabie Saoudite", dialCode: '+966' },
  { id: 'AR', flag: '🇦🇷', name: "Argentine", dialCode: '+54' },
  { id: 'AM', flag: '🇦🇲', name: "Arménie", dialCode: '+374' },
  { id: 'AW', flag: '🇦🇼', name: "Aruba", dialCode: '+297' },
  { id: 'AU', flag: '🇦🇺', name: "Australie", dialCode: '+61' },
  { id: 'AT', flag: '🇦🇹', name: "Autriche", dialCode: '+43' },
  { id: 'AZ', flag: '🇦🇿', name: "Azerbaïdjan", dialCode: '+994' },
  { id: 'BS', flag: '🇧🇸', name: "Bahamas", dialCode: '+1242' },
  { id: 'BH', flag: '🇧🇭', name: "Bahreïn", dialCode: '+973' },
  { id: 'BD', flag: '🇧🇩', name: "Bangladesh", dialCode: '+880' },
  { id: 'BB', flag: '🇧🇧', name: "Barbade", dialCode: '+1246' },
  { id: 'BE', flag: '🇧🇪', name: "Belgique", dialCode: '+32' },
  { id: 'BZ', flag: '🇧🇿', name: "Belize", dialCode: '+501' },
  { id: 'BJ', flag: '🇧🇯', name: "Bénin", dialCode: '+229' },
  { id: 'BM', flag: '🇧🇲', name: "Bermudes", dialCode: '+1441' },
  { id: 'BT', flag: '🇧🇹', name: "Bhoutan", dialCode: '+975' },
  { id: 'BY', flag: '🇧🇾', name: "Biélorussie", dialCode: '+375' },
  { id: 'MM', flag: '🇲🇲', name: "Birmanie", dialCode: '+95' },
  { id: 'BO', flag: '🇧🇴', name: "Bolivie", dialCode: '+591' },
  { id: 'BA', flag: '🇧🇦', name: "Bosnie-Herzégovine", dialCode: '+387' },
  { id: 'BW', flag: '🇧🇼', name: "Botswana", dialCode: '+267' },
  { id: 'BR', flag: '🇧🇷', name: "Brésil", dialCode: '+55' },
  { id: 'BN', flag: '🇧🇳', name: "Brunei", dialCode: '+673' },
  { id: 'BG', flag: '🇧🇬', name: "Bulgarie", dialCode: '+359' },
  { id: 'BF', flag: '🇧🇫', name: "Burkina Faso", dialCode: '+226' },
  { id: 'BI', flag: '🇧🇮', name: "Burundi", dialCode: '+257' },
  { id: 'KH', flag: '🇰🇭', name: "Cambodge", dialCode: '+855' },
  { id: 'CM', flag: '🇨🇲', name: "Cameroun", dialCode: '+237' },
  { id: 'CA', flag: '🇨🇦', name: "Canada", dialCode: '+1' },
  { id: 'CL', flag: '🇨🇱', name: "Chili", dialCode: '+56' },
  { id: 'CN', flag: '🇨🇳', name: "Chine", dialCode: '+86' },
  { id: 'CY', flag: '🇨🇾', name: "Chypre", dialCode: '+357' },
  { id: 'VA', flag: '🇻🇦', name: "Cité du Vatican", dialCode: '+379' },
  { id: 'CO', flag: '🇨🇴', name: "Colombie", dialCode: '+57' },
  { id: 'KM', flag: '🇰🇲', name: "Comores", dialCode: '+269' },
  { id: 'CG', flag: '🇨🇬', name: "Congo", dialCode: '+242' },
  { id: 'CD', flag: '🇨🇩', name: "Congo (Rép. dém.)", dialCode: '+243' },
  { id: 'KP', flag: '🇰🇵', name: "Corée du Nord", dialCode: '+850' },
  { id: 'KR', flag: '🇰🇷', name: "Corée du Sud", dialCode: '+82' },
  { id: 'CR', flag: '🇨🇷', name: "Costa Rica", dialCode: '+506' },
  { id: 'CI', flag: '🇨🇮', name: "Côte d'Ivoire", dialCode: '+225' },
  { id: 'HR', flag: '🇭🇷', name: "Croatie", dialCode: '+385' },
  { id: 'CU', flag: '🇨🇺', name: "Cuba", dialCode: '+53' },
  { id: 'CW', flag: '🇨🇼', name: "Curaçao", dialCode: '+599' },
  { id: 'DK', flag: '🇩🇰', name: "Danemark", dialCode: '+45' },
  { id: 'DJ', flag: '🇩🇯', name: "Djibouti", dialCode: '+253' },
  { id: 'DM', flag: '🇩🇲', name: "Dominique", dialCode: '+1767' },
  { id: 'EG', flag: '🇪🇬', name: "Égypte", dialCode: '+20' },
  { id: 'AE', flag: '🇦🇪', name: "Émirats arabes unis", dialCode: '+971' },
  { id: 'EC', flag: '🇪🇨', name: "Équateur", dialCode: '+593' },
  { id: 'ER', flag: '🇪🇷', name: "Érythrée", dialCode: '+291' },
  { id: 'ES', flag: '🇪🇸', name: "Espagne", dialCode: '+34' },
  { id: 'EE', flag: '🇪🇪', name: "Estonie", dialCode: '+372' },
  { id: 'US', flag: '🇺🇸', name: "États-Unis", dialCode: '+1' },
  { id: 'ET', flag: '🇪🇹', name: "Éthiopie", dialCode: '+251' },
  { id: 'FJ', flag: '🇫🇯', name: "Fidji", dialCode: '+679' },
  { id: 'FI', flag: '🇫🇮', name: "Finlande", dialCode: '+358' },
  { id: 'FR', flag: '🇫🇷', name: "France", dialCode: '+33' },
  { id: 'GA', flag: '🇬🇦', name: "Gabon", dialCode: '+241' },
  { id: 'GM', flag: '🇬🇲', name: "Gambie", dialCode: '+220' },
  { id: 'GE', flag: '🇬🇪', name: "Géorgie", dialCode: '+995' },
  { id: 'GS', flag: '🇬🇸', name: "Géorgie du Sud-et-les Îles Sandwich du Sud", dialCode: '+500' },
  { id: 'GH', flag: '🇬🇭', name: "Ghana", dialCode: '+233' },
  { id: 'GI', flag: '🇬🇮', name: "Gibraltar", dialCode: '+350' },
  { id: 'GR', flag: '🇬🇷', name: "Grèce", dialCode: '+30' },
  { id: 'GD', flag: '🇬🇩', name: "Grenade", dialCode: '+1473' },
  { id: 'GL', flag: '🇬🇱', name: "Groenland", dialCode: '+299' },
  { id: 'GP', flag: '🇬🇵', name: "Guadeloupe", dialCode: '+590' },
  { id: 'GU', flag: '🇬🇺', name: "Guam", dialCode: '+1671' },
  { id: 'GT', flag: '🇬🇹', name: "Guatemala", dialCode: '+502' },
  { id: 'GG', flag: '🇬🇬', name: "Guernesey", dialCode: '+44' },
  { id: 'GN', flag: '🇬🇳', name: "Guinée", dialCode: '+224' },
  { id: 'GQ', flag: '🇬🇶', name: "Guinée équatoriale", dialCode: '+240' },
  { id: 'GW', flag: '🇬🇼', name: "Guinée-Bissau", dialCode: '+245' },
  { id: 'GY', flag: '🇬🇾', name: "Guyana", dialCode: '+592' },
  { id: 'GF', flag: '🇬🇫', name: "Guyane", dialCode: '+594' },
  { id: 'HT', flag: '🇭🇹', name: "Haïti", dialCode: '+509' },
  { id: 'HN', flag: '🇭🇳', name: "Honduras", dialCode: '+504' },
  { id: 'HK', flag: '🇭🇰', name: "Hong Kong", dialCode: '+852' },
  { id: 'HU', flag: '🇭🇺', name: "Hongrie", dialCode: '+36' },
  { id: 'BV', flag: '🇧🇻', name: "Île Bouvet", dialCode: '+47' },
  { id: 'CX', flag: '🇨🇽', name: "Île Christmas", dialCode: '+61' },
  { id: 'IM', flag: '🇮🇲', name: "Île de Man", dialCode: '+44' },
  { id: 'MU', flag: '🇲🇺', name: "Île Maurice", dialCode: '+230' },
  { id: 'NF', flag: '🇳🇫', name: "Île Norfolk", dialCode: '+672' },
  { id: 'KY', flag: '🇰🇾', name: "Îles Caïmans", dialCode: '+1345' },
  { id: 'CC', flag: '🇨🇨', name: "Îles Cocos", dialCode: '+61' },
  { id: 'CK', flag: '🇨🇰', name: "Îles Cook", dialCode: '+682' },
  { id: 'CV', flag: '🇨🇻', name: "Îles du Cap-Vert", dialCode: '+238' },
  { id: 'FO', flag: '🇫🇴', name: "Îles Féroé", dialCode: '+298' },
  { id: 'FK', flag: '🇫🇰', name: "Îles Malouines", dialCode: '+500' },
  { id: 'MP', flag: '🇲🇵', name: "Îles Mariannes du Nord", dialCode: '+1670' },
  { id: 'MH', flag: '🇲🇭', name: "Îles Marshall", dialCode: '+692' },
  { id: 'UM', flag: '🇺🇲', name: "Îles mineures éloignées des États-Unis", dialCode: '+268' },
  { id: 'PN', flag: '🇵🇳', name: "Îles Pitcairn", dialCode: '+64' },
  { id: 'SB', flag: '🇸🇧', name: "Îles Salomon", dialCode: '+677' },
  { id: 'TC', flag: '🇹🇨', name: "Îles Turques-et-Caïques", dialCode: '+1649' },
  { id: 'VG', flag: '🇻🇬', name: "Îles Vierges britanniques", dialCode: '+1284' },
  { id: 'VI', flag: '🇻🇮', name: "Îles Vierges des États-Unis", dialCode: '+1340' },
  { id: 'IN', flag: '🇮🇳', name: "Inde", dialCode: '+91' },
  { id: 'ID', flag: '🇮🇩', name: "Indonésie", dialCode: '+62' },
  { id: 'IQ', flag: '🇮🇶', name: "Irak", dialCode: '+964' },
  { id: 'IR', flag: '🇮🇷', name: "Iran", dialCode: '+98' },
  { id: 'IE', flag: '🇮🇪', name: "Irlande", dialCode: '+353' },
  { id: 'IS', flag: '🇮🇸', name: "Islande", dialCode: '+354' },
  { id: 'IL', flag: '🇮🇱', name: "Israël", dialCode: '+972' },
  { id: 'IT', flag: '🇮🇹', name: "Italie", dialCode: '+39' },
  { id: 'JM', flag: '🇯🇲', name: "Jamaïque", dialCode: '+1876' },
  { id: 'JP', flag: '🇯🇵', name: "Japon", dialCode: '+81' },
  { id: 'JE', flag: '🇯🇪', name: "Jersey", dialCode: '+44' },
  { id: 'JO', flag: '🇯🇴', name: "Jordanie", dialCode: '+962' },
  { id: 'KZ', flag: '🇰🇿', name: "Kazakhstan", dialCode: '+7' },
  { id: 'KE', flag: '🇰🇪', name: "Kenya", dialCode: '+254' },
  { id: 'KG', flag: '🇰🇬', name: "Kirghizistan", dialCode: '+996' },
  { id: 'KI', flag: '🇰🇮', name: "Kiribati", dialCode: '+686' },
  { id: 'XK', flag: '🇽🇰', name: "Kosovo", dialCode: '+383' },
  { id: 'KW', flag: '🇰🇼', name: "Koweït", dialCode: '+965' },
  { id: 'LA', flag: '🇱🇦', name: "Laos", dialCode: '+856' },
  { id: 'LS', flag: '🇱🇸', name: "Lesotho", dialCode: '+266' },
  { id: 'LV', flag: '🇱🇻', name: "Lettonie", dialCode: '+371' },
  { id: 'LB', flag: '🇱🇧', name: "Liban", dialCode: '+961' },
  { id: 'LR', flag: '🇱🇷', name: "Liberia", dialCode: '+231' },
  { id: 'LY', flag: '🇱🇾', name: "Libye", dialCode: '+218' },
  { id: 'LI', flag: '🇱🇮', name: "Liechtenstein", dialCode: '+423' },
  { id: 'LT', flag: '🇱🇹', name: "Lituanie", dialCode: '+370' },
  { id: 'LU', flag: '🇱🇺', name: "Luxembourg", dialCode: '+352' },
  { id: 'MO', flag: '🇲🇴', name: "Macao", dialCode: '+853' },
  { id: 'MK', flag: '🇲🇰', name: "Macédoine du Nord", dialCode: '+389' },
  { id: 'MG', flag: '🇲🇬', name: "Madagascar", dialCode: '+261' },
  { id: 'MY', flag: '🇲🇾', name: "Malaisie", dialCode: '+60' },
  { id: 'MW', flag: '🇲🇼', name: "Malawi", dialCode: '+265' },
  { id: 'MV', flag: '🇲🇻', name: "Maldives", dialCode: '+960' },
  { id: 'ML', flag: '🇲🇱', name: "Mali", dialCode: '+223' },
  { id: 'MT', flag: '🇲🇹', name: "Malte", dialCode: '+356' },
  { id: 'MA', flag: '🇲🇦', name: "Maroc", dialCode: '+212' },
  { id: 'MQ', flag: '🇲🇶', name: "Martinique", dialCode: '+596' },
  { id: 'MR', flag: '🇲🇷', name: "Mauritanie", dialCode: '+222' },
  { id: 'YT', flag: '🇾🇹', name: "Mayotte", dialCode: '+262' },
  { id: 'MX', flag: '🇲🇽', name: "Mexique", dialCode: '+52' },
  { id: 'FM', flag: '🇫🇲', name: "Micronésie", dialCode: '+691' },
  { id: 'MD', flag: '🇲🇩', name: "Moldavie", dialCode: '+373' },
  { id: 'MC', flag: '🇲🇨', name: "Monaco", dialCode: '+377' },
  { id: 'MN', flag: '🇲🇳', name: "Mongolie", dialCode: '+976' },
  { id: 'ME', flag: '🇲🇪', name: "Monténégro", dialCode: '+382' },
  { id: 'MS', flag: '🇲🇸', name: "Montserrat", dialCode: '+1664' },
  { id: 'MZ', flag: '🇲🇿', name: "Mozambique", dialCode: '+258' },
  { id: 'NA', flag: '🇳🇦', name: "Namibie", dialCode: '+264' },
  { id: 'NR', flag: '🇳🇷', name: "Nauru", dialCode: '+674' },
  { id: 'NP', flag: '🇳🇵', name: "Népal", dialCode: '+977' },
  { id: 'NI', flag: '🇳🇮', name: "Nicaragua", dialCode: '+505' },
  { id: 'NE', flag: '🇳🇪', name: "Niger", dialCode: '+227' },
  { id: 'NG', flag: '🇳🇬', name: "Nigéria", dialCode: '+234' },
  { id: 'NU', flag: '🇳🇺', name: "Niue", dialCode: '+683' },
  { id: 'NO', flag: '🇳🇴', name: "Norvège", dialCode: '+47' },
  { id: 'NC', flag: '🇳🇨', name: "Nouvelle-Calédonie", dialCode: '+687' },
  { id: 'NZ', flag: '🇳🇿', name: "Nouvelle-Zélande", dialCode: '+64' },
  { id: 'OM', flag: '🇴🇲', name: "Oman", dialCode: '+968' },
  { id: 'UG', flag: '🇺🇬', name: "Ouganda", dialCode: '+256' },
  { id: 'UZ', flag: '🇺🇿', name: "Ouzbékistan", dialCode: '+998' },
  { id: 'PK', flag: '🇵🇰', name: "Pakistan", dialCode: '+92' },
  { id: 'PW', flag: '🇵🇼', name: "Palaos (Palau)", dialCode: '+680' },
  { id: 'PS', flag: '🇵🇸', name: "Palestine", dialCode: '+970' },
  { id: 'PA', flag: '🇵🇦', name: "Panama", dialCode: '+507' },
  { id: 'PG', flag: '🇵🇬', name: "Papouasie-Nouvelle-Guinée", dialCode: '+675' },
  { id: 'PY', flag: '🇵🇾', name: "Paraguay", dialCode: '+595' },
  { id: 'NL', flag: '🇳🇱', name: "Pays-Bas", dialCode: '+31' },
  { id: 'BQ', flag: '🇧🇶', name: "Pays-Bas caribéens", dialCode: '+599' },
  { id: 'PE', flag: '🇵🇪', name: "Pérou", dialCode: '+51' },
  { id: 'PH', flag: '🇵🇭', name: "Philippines", dialCode: '+63' },
  { id: 'PL', flag: '🇵🇱', name: "Pologne", dialCode: '+48' },
  { id: 'PF', flag: '🇵🇫', name: "Polynésie française", dialCode: '+689' },
  { id: 'PR', flag: '🇵🇷', name: "Porto Rico", dialCode: '+1' },
  { id: 'PT', flag: '🇵🇹', name: "Portugal", dialCode: '+351' },
  { id: 'QA', flag: '🇶🇦', name: "Qatar", dialCode: '+974' },
  { id: 'CF', flag: '🇨🇫', name: "République centrafricaine", dialCode: '+236' },
  { id: 'DO', flag: '🇩🇴', name: "République dominicaine", dialCode: '+1' },
  { id: 'RE', flag: '🇷🇪', name: "Réunion", dialCode: '+262' },
  { id: 'RO', flag: '🇷🇴', name: "Roumanie", dialCode: '+40' },
  { id: 'GB', flag: '🇬🇧', name: "Royaume-Uni", dialCode: '+44' },
  { id: 'RU', flag: '🇷🇺', name: "Russie", dialCode: '+7' },
  { id: 'RW', flag: '🇷🇼', name: "Rwanda", dialCode: '+250' },
  { id: 'EH', flag: '🇪🇭', name: "Sahara Occidental", dialCode: '+212' },
  { id: 'BL', flag: '🇧🇱', name: "Saint-Barthélemy", dialCode: '+590' },
  { id: 'KN', flag: '🇰🇳', name: "Saint-Christophe-et-Niévès", dialCode: '+1869' },
  { id: 'SM', flag: '🇸🇲', name: "Saint-Marin", dialCode: '+378' },
  { id: 'MF', flag: '🇲🇫', name: "Saint-Martin", dialCode: '+590' },
  { id: 'SX', flag: '🇸🇽', name: "Saint-Martin", dialCode: '+1721' },
  { id: 'PM', flag: '🇵🇲', name: "Saint-Pierre-et-Miquelon", dialCode: '+508' },
  { id: 'VC', flag: '🇻🇨', name: "Saint-Vincent-et-les-Grenadines", dialCode: '+1784' },
  { id: 'SH', flag: '🇸🇭', name: "Sainte-Hélène, Ascension et Tristan da Cunha", dialCode: '+290' },
  { id: 'LC', flag: '🇱🇨', name: "Sainte-Lucie", dialCode: '+1758' },
  { id: 'SV', flag: '🇸🇻', name: "Salvador", dialCode: '+503' },
  { id: 'WS', flag: '🇼🇸', name: "Samoa", dialCode: '+685' },
  { id: 'AS', flag: '🇦🇸', name: "Samoa américaines", dialCode: '+1684' },
  { id: 'ST', flag: '🇸🇹', name: "São Tomé et Príncipe", dialCode: '+239' },
  { id: 'SN', flag: '🇸🇳', name: "Sénégal", dialCode: '+221' },
  { id: 'RS', flag: '🇷🇸', name: "Serbie", dialCode: '+381' },
  { id: 'SC', flag: '🇸🇨', name: "Seychelles", dialCode: '+248' },
  { id: 'SL', flag: '🇸🇱', name: "Sierra Leone", dialCode: '+232' },
  { id: 'SG', flag: '🇸🇬', name: "Singapour", dialCode: '+65' },
  { id: 'SK', flag: '🇸🇰', name: "Slovaquie", dialCode: '+421' },
  { id: 'SI', flag: '🇸🇮', name: "Slovénie", dialCode: '+386' },
  { id: 'SO', flag: '🇸🇴', name: "Somalie", dialCode: '+252' },
  { id: 'SD', flag: '🇸🇩', name: "Soudan", dialCode: '+249' },
  { id: 'SS', flag: '🇸🇸', name: "Soudan du Sud", dialCode: '+211' },
  { id: 'LK', flag: '🇱🇰', name: "Sri Lanka", dialCode: '+94' },
  { id: 'SE', flag: '🇸🇪', name: "Suède", dialCode: '+46' },
  { id: 'CH', flag: '🇨🇭', name: "Suisse", dialCode: '+41' },
  { id: 'SR', flag: '🇸🇷', name: "Surinam", dialCode: '+597' },
  { id: 'SJ', flag: '🇸🇯', name: "Svalbard et Jan Mayen", dialCode: '+47' },
  { id: 'SZ', flag: '🇸🇿', name: "Swaziland", dialCode: '+268' },
  { id: 'SY', flag: '🇸🇾', name: "Syrie", dialCode: '+963' },
  { id: 'TJ', flag: '🇹🇯', name: "Tadjikistan", dialCode: '+992' },
  { id: 'TW', flag: '🇹🇼', name: "Taïwan", dialCode: '+886' },
  { id: 'TZ', flag: '🇹🇿', name: "Tanzanie", dialCode: '+255' },
  { id: 'TD', flag: '🇹🇩', name: "Tchad", dialCode: '+235' },
  { id: 'CZ', flag: '🇨🇿', name: "Tchéquie", dialCode: '+420' },
  { id: 'TF', flag: '🇹🇫', name: "Terres australes et antarctiques françaises", dialCode: '+262' },
  { id: 'IO', flag: '🇮🇴', name: "Territoire britannique de l'océan Indien", dialCode: '+246' },
  { id: 'TH', flag: '🇹🇭', name: "Thaïlande", dialCode: '+66' },
  { id: 'TL', flag: '🇹🇱', name: "Timor oriental", dialCode: '+670' },
  { id: 'TG', flag: '🇹🇬', name: "Togo", dialCode: '+228' },
  { id: 'TK', flag: '🇹🇰', name: "Tokelau", dialCode: '+690' },
  { id: 'TO', flag: '🇹🇴', name: "Tonga", dialCode: '+676' },
  { id: 'TT', flag: '🇹🇹', name: "Trinité-et-Tobago", dialCode: '+1868' },
  { id: 'TN', flag: '🇹🇳', name: "Tunisie", dialCode: '+216' },
  { id: 'TM', flag: '🇹🇲', name: "Turkménistan", dialCode: '+993' },
  { id: 'TR', flag: '🇹🇷', name: "Turquie", dialCode: '+90' },
  { id: 'TV', flag: '🇹🇻', name: "Tuvalu", dialCode: '+688' },
  { id: 'UA', flag: '🇺🇦', name: "Ukraine", dialCode: '+380' },
  { id: 'UY', flag: '🇺🇾', name: "Uruguay", dialCode: '+598' },
  { id: 'VU', flag: '🇻🇺', name: "Vanuatu", dialCode: '+678' },
  { id: 'VE', flag: '🇻🇪', name: "Venezuela", dialCode: '+58' },
  { id: 'VN', flag: '🇻🇳', name: "Viêt Nam", dialCode: '+84' },
  { id: 'WF', flag: '🇼🇫', name: "Wallis-et-Futuna", dialCode: '+681' },
  { id: 'YE', flag: '🇾🇪', name: "Yémen", dialCode: '+967' },
  { id: 'ZM', flag: '🇿🇲', name: "Zambie", dialCode: '+260' },
  { id: 'ZW', flag: '🇿🇼', name: "Zimbabwe", dialCode: '+263' },
]

/** Devine le pays à préselectionner dans un CountryCodePicker à partir d'un numéro E.164 déjà connu
 *  (typiquement le téléphone du propriétaire ou de la boutique) — plutôt qu'un +224 (Guinée) figé,
 *  cf. Team.tsx et NewArrival.tsx ("Ajouter un membre" / "+ Nouveau" fournisseur). Le préfixe dialCode
 *  le plus long qui matche l'emporte (+224 vs +22x se chevauchent sur le premier chiffre). */
export function countryIdFromPhone(phone: string | null | undefined): string {
  if (!phone) return 'GN'
  const match = [...PHONE_COUNTRIES].sort((a, b) => b.dialCode.length - a.dialCode.length).find((c) => phone.startsWith(c.dialCode))
  return match?.id ?? 'GN'
}

/** Découpe un numéro E.164 en (pays, numéro national) pour préremplir un champ "indicatif + numéro". */
export function splitE164Phone(phone: string | null | undefined): { countryId: string; national: string } {
  const countryId = countryIdFromPhone(phone)
  const dial = PHONE_COUNTRIES.find((c) => c.id === countryId)?.dialCode ?? ''
  return { countryId, national: phone && phone.startsWith(dial) ? phone.slice(dial.length) : '' }
}
